import { Grid } from "@mui/material";
import { FC, ReactNode } from "react";

export const Layout: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      py={8}
      spacing={3}
      sx={{
        width: "100%",
        maxWidth: "1300px",
        margin: "0 auto",
        pr: 3
      }}
    >
      {children}
    </Grid>
  );
};
